<template>
  <div id="security-guard" class="security-guard" data-sidebar="7" data-position="1" data-name="安全">
    <div v-if="isMobile" class="security-guard-title ffm600" v-animate>自然舒适<br>值得信赖</div>
    <div v-else class="security-guard-title ffm600" v-animate>自然舒适，值得信赖</div>
    <div class="security-guard-privacy" v-animate>
      <div class="security-guard-privacy-content">
        <p class="sg-module-content ffm600">
          <span>全面拥抱AI，</span><br />
          <span>隐私保护更出色</span>
        </p>
        <p class="sg-module-desc ffm400">
          vivo打造CHADME六维AI安全范式——从“芯片、端侧、云侧、数据、模型与人”六大维度，构建覆盖AI全生命周期安全。基于此范式，蓝心小V获得了中国信通院颁发的《AIGC产品和服务用户权益保护认证-卓越型》，这是该系列安全评测的最高水平。vivo希望用户能够无忧地享受AI带来的便捷与乐趣。
        </p>
        <p class="sg-module-more ffm400">
          <a href="https://privacy.vivo.com.cn/#/overview"
            target="_blank"
            data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',module:'安全守护',button_name:'点击了解更多'}}">点击了解更多
            &gt;</a>
        </p>
      </div>
      <div class="security-guard-privacy-img">
        <PlusImage v-if="isPC" :src="IMAGES.securityGuard.privacy" alt="" />
        <PlusImage v-else-if="isPad" :src="IMAGES.securityGuard.privacyPad" alt="" />
        <PlusImage v-else :src="IMAGES.securityGuard.privacyH5" alt="" />
      </div>
    </div>
    <div class="security-guard-auth" v-animate>
      <div class="security-guard-auth-content ffm600">
        <span>我们通过了多个</span><br />
        <span>权威安全机构认证和测评</span>
      </div>
      <div class="security-guard-auth-img">
        <PlusImage v-if="isPC" :src="IMAGES.securityGuard.auth" alt="" />
        <PlusImage v-else-if="isPad" :src="IMAGES.securityGuard.authPad" alt="" />
        <PlusImage v-else :src="IMAGES.securityGuard.authH5" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import IMAGES from '@/config/image.js'
import { initExposureTrack } from '@/utils/track.js'
export default {
  name: "SecurityGuard",
  data() {
    return {
      IMAGES
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'isPad', 'isPC']),
  },

  methods: {

  },

  mounted() {
    initExposureTrack('.security-guard')()
  }
}
</script>
<style lang="scss" scoped>
.security-guard {
  padding: 140 * $px1920vw + vw 0 128 * $px1920vw + vw 0;
  background-color: #000204;
  position: relative;

  .security-guard-title {
    width: fit-content;
    margin: 0 auto;
    font-size: 96* $px1920vw + vw;
    font-weight: 650;
    line-height: 116* $px1920vw + vw;
    text-align: center;
    background: linear-gradient(270deg, #DFCCAF 0%, #FFFFFF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }

  .security-guard-privacy {
    width: 100%;
    height: 600 * $px1920vw + vw;
    padding-left: 360 * $px1920vw + vw;
    margin-top: 120 * $px1920vw + vw;
    position: relative;

    .security-guard-privacy-content {
      width: 543.06 * $px1920vw + vw;
      padding-top: 41 * $px1920vw + vw;
      position: relative;
      z-index: 2;

      .sg-module-content {
        font-size: 64 * $px1920vw + vw;
        line-height: 77 * $px1920vw + vw;
        color: #ffffff;
        text-align: left;
      }

      .sg-module-desc {
        margin-top: 25 * $px1920vw + vw;
        font-size: 18 * $px1920vw + vw;
        line-height: 25.2 * $px1920vw + vw;
        color: rgba(255, 255, 255, 0.8);
        opacity: 0.9;
        text-align: left;
      }

      .sg-module-more {
        margin-top: 59 * $px1920vw + vw;
        text-align: left;

        a {
          display: block;
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: #ffffff;
        }
      }
    }

    .security-guard-privacy-img {
      position: absolute;
      top: 0;
      right: 190 * $px1920vw + vw;
      width: 800 * $px1920vw + vw;
      height: 600 * $px1920vw + vw;

      picture, img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .security-guard-auth {
    width: 100%;
    margin: 0 auto;
    .security-guard-auth-content {
      font-size: 64 * $px1920vw + vw;
      line-height: 77 * $px1920vw + vw;
      text-align: left;
      color: #ffffff;
      padding-left: 360 * $px1920vw + vw;
    }

    .security-guard-auth-img {
      width: 100%;
      height: 115 * $px1920vw + vw;
      margin: 32 * $px1920vw + vw 0 0 0;
      font-size: 0;
      picture, img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.isPad {
  .security-guard {
    padding: 66 * $px676vw + vw 0 48 * $px676vw + vw 0;

    .security-guard-title {
      font-size: 42 * $px676vw + vw;
      line-height: 49 * $px676vw + vw;
    }

    .security-guard-privacy {
      height: 331 * $px676vw + vw;
      padding-left: 58 * $px676vw + vw;
      margin-top: 71 * $px676vw + vw;

      .security-guard-privacy-content {
        width: 240 * $px676vw + vw;
        padding-top: 37 * $px676vw + vw;

        .sg-module-content {
          font-size: 29 * $px676vw + vw;
          line-height: 35 * $px676vw + vw;
        }

        .sg-module-desc {
          margin-top: 14.68 * $px676vw + vw;
          font-size: 11.66 * $px676vw + vw;
          line-height: 15.54 * $px676vw + vw;
          color: rgba(255, 255, 255, 0.6);
          opacity: 0.9;
        }

        .sg-module-more {
          margin-top: 19  * $px676vw + vw;
          text-align: left;

          a {
            display: block;
            font-size: 12 * $px676vw + vw;
            line-height: 12 * $px676vw + vw;
          }
        }
      }

      .security-guard-privacy-img {
        width: 320 * $px676vw + vw;
        height: 240 * $px676vw + vw;
        right: 40 * $px676vw + vw;
        top: 91 * $px676vw + vw;
        picture, img {
          width: 320 * $px676vw + vw;
          height: auto;
        }
      }
    }

    .security-guard-auth {
      margin-top: -12 * $px676vw + vw;
      height: auto;
      position: relative;
      .security-guard-auth-content {
        font-size: 29 * $px676vw + vw;
        line-height: 35 * $px676vw + vw;
        padding-left: 58 * $px676vw + vw;
        position: relative;
        z-index: 1;
      }

      .security-guard-auth-img {
        width: 560 * $px676vw + vw;
        height: 30.53 * $px676vw + vw;
        margin: 33.8 * $px676vw + vw auto 0 auto;
        picture, img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.isMobile {
  .security-guard {
    padding: 41 * $px360vw + vw 0 63 * $px360vw + vw 0;
    .security-guard-title {
      font-size: 42 * $px360vw + vw;
      line-height: 49 * $px360vw + vw;
      width: fit-content;
      margin: 0 auto;
    }
    .security-guard-privacy {
      margin-top: 96 * $px360vw + vw;
      padding-left: 0;
      height: auto;
      
      display: inline-block;
      .security-guard-privacy-content {
        padding-top: 0;
        padding-left: 20 * $px360vw + vw;
        padding-right: 19 * $px360vw + vw;
        width: auto;
        .sg-module-content {
          font-size: 25 * $px360vw + vw;
          line-height: 33 * $px360vw + vw;
          color: #ffffff;
        }
        .sg-module-desc {
          font-size: 12 * $px360vw + vw;
          line-height: 16 * $px360vw + vw;
          color: #A1A1A6;
          opacity: 0.9;
          margin-top: 25 * $px360vw + vw;
        }
        .sg-module-more {
          margin-top: 14 * $px360vw + vw;
          a {
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            color: #fff;
          }
        }
      }

      .security-guard-privacy-img {
        width: 360 * $px360vw + vw;
        height: auto;
        margin-left: 0;
        position: relative;
        top: 0;
        right: 0;
        margin-top: 24 * $px360vw + vw;
      }
    }

    .security-guard-auth {
      padding-left: 0;
      position: relative;
      height: auto;
      margin: 0;
      .security-guard-auth-content {
        font-size: 20 * $px360vw + vw;
        line-height: 26 * $px360vw + vw;
        padding-left: 20 * $px360vw + vw;
        position: relative;
        z-index: 1;
      }
      .security-guard-auth-img {
        width: 306.67 * $px360vw + vw;
        height: 173.73 * $px360vw + vw;
        margin: 24 * $px360vw + vw auto 0 auto;
        font-size: 0;
        picture, img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

@media (prefers-color-scheme: dark) {
  .isMobile {
    .security-guard {
      .security-guard-title {
        background: linear-gradient(270deg, #aa9b83 0%, #a6a6a6 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
    }
  }
}
</style>